import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  clients: {
    data: [],
    loading: false,
    error: null,
  },
  selectedClient: {
    data: {},
    loading: false,
  },
};

export const getClients = createAsyncThunk("clients/getClients", async () => {
  try {
    const response = await httpClient.get("/web/users/by-role/USER");
    return response.data.res;
  } catch (error) {
    const customError = {
      name: "Custom axios error",
      message: error.response.data.message,
      data: error.response.data,
    };
    throw customError;
  }
});

export const getClientById = createAsyncThunk(
  "clients/getClientById",
  async (id) => {
    try {
      const response = await httpClient.get(`/web/users/${id}`);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const changeClientStatus = createAsyncThunk(
  "clients/changeClientStatus",
  async (data) => {
    try {
      const response = await httpClient.put("/web/users/status", data);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const clientSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClients.pending, (state) => {
        state.clients.loading = true;
      })
      .addCase(getClients.fulfilled, (state, action) => {
        state.clients.data = action.payload;
        state.clients.loading = false;
      })
      .addCase(getClients.rejected, (state, action) => {
        state.clients.error = action.error.message;
        state.clients.loading = false;
      })
      .addCase(getClientById.pending, (state) => {
        state.selectedClient.loading = true;
      })
      .addCase(getClientById.fulfilled, (state, action) => {
        state.selectedClient.data = action.payload;
        state.selectedClient.loading = false;
      })
      .addCase(getClientById.rejected, (state, action) => {
        state.selectedClient.loading = false;
      })
      .addCase(changeClientStatus.fulfilled, (state, action) => {
        const index = state.clients.data.findIndex(
          (client) => client._id === action.payload._id
        );
        state.clients.data[index] = action.payload;
      })
      .addCase(changeClientStatus.pending, (state) => {
        state.clients.loading = true;
      })
      .addCase(changeClientStatus.rejected, (state, action) => {
        state.clients.error = action.error.message;
      });
  },
});

export default clientSlice.reducer;
